import { FormGroupDefinition } from './form-group-definition';

export interface SteppedFormGroupDefinition {
  title: string;
  key: string;
  hide?: boolean;
  groups: FormGroupDefinition[];
}
